/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeRTSStep5Page() {
  customValidationInit(false);
  aspControlValidationInit();
}
